/** B 端侧边栏菜单：一级分组 + 二级页面，按角色过滤（子项可单独限制角色） */
export const MENU_GROUPS = [
  {
    key: 'knowledge',
    label: '知识库',
    icon: '',
    roles: ['admin', 'creator'],
    children: [
      { path: '/knowledge', label: '知识库列表', icon: '' },
      { path: '/upload', label: '文档上传', icon: '' },
      { path: '/preset', label: '系统预设FAQ', icon: '' },
      { path: '/feedback', label: '用户反馈收集', icon: '' }
    ]
  },
  {
    key: 'exam-admin',
    label: '润得智学',
    icon: '',
    roles: ['admin', 'creator'],
    children: [
      { path: '/exam/questions', label: '题库管理', icon: '' },
      { path: '/exam/manage', label: '试卷管理', icon: '' },
      { path: '/exam/ranking', label: '成绩管理', icon: '' }
    ]
  },
  {
    key: 'account',
    label: '系统',
    icon: '',
    roles: ['admin', 'creator'],
    children: [
      { path: '/password', label: '修改密码', icon: '' },
      { path: '/accounts', label: '账号管理', icon: '', roles: ['admin'] }
    ]
  },
  {
    key: 'exam-examinee',
    label: '润得智学',
    icon: '',
    roles: ['examinee'],
    children: [
      { path: '/exam/my-exams', label: '我的考试', icon: '' },
      { path: '/exam/my-scores', label: '我的成绩', icon: '' }
    ]
  }
]

export function getMenuGroups(role) {
  return MENU_GROUPS
    .filter(g => g.roles.includes(role))
    .map(g => ({ ...g, children: g.children.filter(c => !c.roles || c.roles.includes(role)) }))
    .filter(g => g.children.length)
}

export function getDefaultRoute(role) {
  if (role === 'examinee') return '/exam/my-exams'
  return '/knowledge'
}
